// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xDYo","value":"styles_value__1AmvV","placeholder":"styles_placeholder__8kyTk","items":"styles_items__386WL","item":"styles_item__18tAx"};